<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      flag: false,
    };
  },
  created() {
    if (parseInt(this.$route.params.mode, 16) === 1) {
      this.$router.push({ path: '/layout/registration' });
      // this.$router.push({
      //   path
      //   // params: { openRegistration: this.$route.params.id },
      // });
    } else if (parseInt(this.$route.params.mode, 16) === 2) {
      this.$router.push({
        name: 'Certificate',
        params: { openCertificate: this.$route.params.id },
      });
    }
  },
};
</script>
<style>
</style>
